import cookiesNotification from './modules/cookiesnotification';
import counter from './modules/counter';
import formValidate from './modules/formvalidate';
import members from './modules/members';
import mobileMenu from './modules/mobilemenu';
import newsletter from './modules/newsletter';
import slider from './modules/slider';
import toplayer from './modules/toplayer';
import support from './modules/support';

cookiesNotification();
counter();
formValidate();
members();
mobileMenu();
newsletter();
slider();
toplayer();
support();
